export default __webpack_public_path__ + "1534528420ab65eb7b9e7bf938abf4f7.png";